/**
 * Routing Configuration
 *
 * Main routing setup and route rendering
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import { Suspense } from 'react'
import LoadingSpinner from '../components/LoadingSpinner'
import { appRoutes } from './routes'

/**
 * App Router Component
 * Renders all application routes with Suspense for lazy loading
 */
export function AppRouter() {
  return (
    <Suspense
      fallback={
        <div className='flex h-screen w-screen items-center justify-center bg-white'>
          <LoadingSpinner />
        </div>
      }
    >
      <Routes>
        {appRoutes.map(route => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        {/* Catch all - redirect to home */}
        <Route path='*' element={<Navigate to='/home' replace />} />
      </Routes>
    </Suspense>
  )
}
